import { Component, h, Prop } from '@stencil/core';
import { iconClassNameFaMap, IconSize, iconSizeMap, IconType } from './uui-icon-type';

const SUPPORTED_VARIANT = 'light';

@Component({
  tag: 'uui-icon',
  styleUrls: ['fontawesome.min.css', 'uui-icon.css'],
  shadow: true
})
export class UUIIcon {
  @Prop({ mutable: true }) type: IconType;
  @Prop({ mutable: true }) size: IconSize;
  @Prop({ mutable: true }) color: string = '#007585';
  @Prop() spin = false;

  render() {
    const { type, size, color } = this;
    const iconClassValue = iconClassNameFaMap[type];
    const classConstant = 'fa-';
    let classes = `${classConstant}${SUPPORTED_VARIANT} ${iconClassValue}`;
    
    if(iconSizeMap[size] !== 'inherit') {
      const iconSize = iconSizeMap[size] || Object.values(iconSizeMap)[0];
      classes += ` ${classConstant}${iconSize}`;
    }

    if (this.spin) {
      classes += ` ${classConstant}spin`;
    }

    return <i style={{ color: color }} class={classes} />;
  }
}
